import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-bg-page relative flex min-h-[365px] flex-col justify-between gap-8 overflow-hidden rounded-[40px] px-18 py-10 pb-55.5 max-xl:h-auto max-xl:px-5 max-xl:px-8 max-xl:py-11 md:pb-10 2xl:flex-row 2xl:px-18',
    mainContent:
      'z-1 flex flex-col justify-center gap-8 xl:mb-0 xl:max-w-[50%] 2xl:gap-[60px]',
    header: 'flex flex-col gap-3',
    title:
      'text-2xl leading-[1.4] font-semibold md:leading-[1.2] md:whitespace-pre-wrap',
    description: 'text-s max-w-[640px] leading-[1.5] font-light md:text-lg',
    contacts: 'flex gap-4 max-md:flex-col md:flex-col md:gap-8 xl:flex-row',
    phoneBlock: 'flex flex-col gap-1',
    contact:
      'm-0 h-fit w-fit p-0 text-2xl leading-[1.2] font-semibold normal-case',
    time: 'text-s text-secondary-hover leading-[1.5] font-light',
    onlineSupport: 'z-1 flex flex-col justify-end gap-3 2xl:items-end 2xl:pb-7',
    onlineSupportTitle:
      'text-s xs:whitespace-normal leading-[1.5] font-semibold whitespace-pre-wrap min-[855px]:whitespace-normal sm:whitespace-pre-wrap 2xl:text-end 2xl:whitespace-pre-wrap',
    chats: 'flex gap-3 md:flex-col xl:flex-row 2xl:justify-end',
    chatButton:
      'hover:bg-blue-dark flex h-8 w-fit cursor-pointer items-center justify-center gap-2 rounded-[100px] bg-white px-3 py-1 leading-[1.5] font-light normal-case no-underline hover:text-white',
    backgroundImage:
      'right-0 bottom-0 -z-0 -mt-13 -mb-11 w-fit md:absolute md:mt-0 md:mb-0 md:h-fit xl:top-0 xl:h-full xl:w-max xl:translate-x-[-10%] 2xl:left-[50%] 2xl:translate-x-[-25%]'
  },
  variants: {
    telegram: {
      true: {
        chatButton: 'hover:bg-[#24A1DE]'
      }
    }
  }
});
